// firebase/firebaseApi.js
// import { auth } from "./firebaseClient";
// import { useUserAuth } from "../../context/UserAuthContext";

async function callApi(path, options = {}, token) {
  const res = await fetch(path, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...options.headers
    }
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

// 导出具体接口
export const fetchPatient     = (phone, token) => callApi(`/api/patients/${phone}`, {}, token);
export const savePatient      = (data, token)  => callApi(`/api/patients`, {
  method: "POST", body: JSON.stringify(data)
}, token);
export const createAppointment= (data, token)  => callApi(`/api/appointments`, {
  method: "POST", body: JSON.stringify(data)
}, token);
export const updateAppointment= (id, data, token) => callApi(`/api/appointments/${id}`, {
  method: "PUT", body: JSON.stringify(data)
}, token);
export const listAppointments = (phone, token) => callApi(`/api/appointments/by-patient/${phone}`, {}, token);
export const aiSchedule       = (cmd, token)   => callApi(`/api/appointments/ai-schedule`, {
  method: "POST", body: JSON.stringify(cmd)
}, token);
export const fetchDoctors       = (token)         => callApi(`/api/doctors`,{},token);